import React from 'react';
import ButtonComp from '@components/UI/Button/Index';
import { useAppAuth } from '@contexts/AuthContext';

const Erro403 = () => {
  const { logout } = useAppAuth();

  const handleGoLogin = async () => {
    logout();
  };

  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light px-3">
      <div
        className="shadow-sm border bg-white rounded-4 p-4 p-md-5 text-center"
        style={{ maxWidth: 560, width: '100%' }}
      >
        {/* Ícone / Badge */}
        <div
          className="d-inline-flex align-items-center justify-content-center rounded-circle mb-4"
          style={{
            width: 90,
            height: 90,
            background: 'linear-gradient(135deg, #2b97be 0%, #1f6e85 60%, #155466 100%)',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
          }}
          aria-hidden="true"
        >
          <i className="fa-solid fa-lock fa-2x text-white"></i>
        </div>

        {/* Título */}
        <h1 className="fw-bold mb-3" style={{ fontSize: 'clamp(1.8rem, 3vw, 2.4rem)' }}>
          Acesso Negado
        </h1>

        {/* Subtítulo / Mensagem */}
        <h6 className="mb-4" style={{ lineHeight: 1.5 }}>
          Por favor, entre em contato com um administrador para solicitar acesso ao sistema antes de tentar novamente.
          Certifique‑se de que sua conta esteja ativa e de que você disponha das permissões necessárias.
        </h6>

        {/* Botão */}
        <div className="d-flex justify-content-center">
          <ButtonComp
            title="VOLTAR PARA O LOGIN"
            onClick={handleGoLogin}
            buttonColor="#2b97be"
            classnameIcon="fa-solid fa-right-to-bracket"
            hoverMessage="Botão para ser redirecionado para tela de login"
          />
        </div>

      </div>
    </div>
  );
};

export default Erro403;
